const ARMOR_ANYWHERE_TEMPLATE_ID = 'add_armor_anywhere';

const CATEGORIES_ICON = {
  '1': 'account',
  '2': 'payment',
  '3': 'server-config',
  '4': 'server-incident',
  '5': 'info-circle',
};

const DEFAULT_SEVERITIES = {
  cloud: 'Normal',
  dedicated: 'Normal',
  faws: 'Normal',
  managed_gcp: {
    aviator: 'Normal',
    runway: 'Low',
    serviceblocks: 'Normal',
  },
};

const NEW_TICKET_QUERYPARAM = 'new_ticket';

const NEW_TICKET_ID_QUERYPARAM = 'new_ticket_id';

const NEW_TICKET_DEDICATED_QUERYPARAM = 'new_ticket_dedicated';

const SERVICE_REQUEST = 'SERVICE REQUEST';

const SEVERITY_DESCRIPTIONS = [
  {
    type: 'low',
    translationKey: 'lowSeverityDesc',
  },
  {
    type: 'normal',
    translationKey: 'normalSeverityDesc',
  },
  {
    type: 'high',
    translationKey: 'highSeverityDesc',
  },
  {
    type: 'urgent',
    translationKey: 'urgentSeverityDesc',
  },
];

const STEP_1 = 0;

const STEP_2 = 1;

const STEP_3 = 2;

// allowing only admin permission accounts, but latter we may need to allow device-admin, ticket-admin to create ticket
const ONLY_ADMIN = true;

const DEVICE_PERMISSION_REQUIRED_ALERT = 'You do not have device permissions';

const SSL_CERTIFICATE_TEMPLATE = 'ssl_certificate';

export {
  ARMOR_ANYWHERE_TEMPLATE_ID,
  CATEGORIES_ICON,
  DEFAULT_SEVERITIES,
  NEW_TICKET_QUERYPARAM,
  NEW_TICKET_ID_QUERYPARAM,
  NEW_TICKET_DEDICATED_QUERYPARAM,
  SERVICE_REQUEST,
  SEVERITY_DESCRIPTIONS,
  SSL_CERTIFICATE_TEMPLATE,
  STEP_1,
  STEP_2,
  STEP_3,
  ONLY_ADMIN,
  DEVICE_PERMISSION_REQUIRED_ALERT,
};
